import React from 'react';
import cx from 'classnames';

import Hero from '~/components/ui/Hero/HeroV2';
import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';

import shared from '~/styles/landingPageShared.module.less';
import css from '~/pages/wedding-registry/how-cash-gifts-work/cash.module.less';

const renderTitle = <>All About Cash and Honeymoon Funds</>;

type CashHeroProps = {
  ctaLink?: string;
  ctaText?: string;
};

const CashGiftsHero: React.FC<CashHeroProps> = ({ ctaLink, ctaText }) => (
  <Hero
    backgroundImage="cashgifts_hero"
    bgImgExtension="png"
    imageDirectory="CashGiftsLP/hero"
    body={
      <div className={cx(shared.dek, css.cashHeroDek)}>
        With direct deposit, zero-fee options, and all the categories you need, Zola is the place to
        register for and receive cash.
      </div>
    }
    buttons={
      <ButtonV3 component="a" href={ctaLink}>
        {ctaText}
      </ButtonV3>
    }
    className={`${css.cashHero} ${css.pngHero}`}
    notVersioned
    title={renderTitle}
  />
);

export default CashGiftsHero;
